import { createTheme , Theme } from '@mui/material/styles';

const theme: Theme = createTheme ({
    typography: {
      fontFamily: 'Poppins, sans-serif',
    },
  });

export default theme;